import { CompanySettings_Read, CompanySettings_Update } from '@treadinc/horizon-api-spec';

// Derived from the sparse update shape rather than CompanySettings_Read because the
// read shape additionally carries row metadata (id, company_id, timestamps) that are
// not settings. Only the boolean settings are toggles; a spec bump that adds a boolean
// setting key widens this union automatically.
export type CompanySettingKey = {
  [Key in keyof CompanySettings_Update]-?: CompanySettings_Read[Key] extends boolean
    ? Key
    : never;
}[keyof CompanySettings_Update];

// The settings this model hydrates: the toggles plus the non-boolean settings the app reads.
// A new non-boolean setting is added here.
type HydratedCompanySettingKey =
  | CompanySettingKey
  | 'default_untaxed_tax_rate_schedule_id';

export class CompanySettings {
  // Partial so the pre-hydration store default (`new CompanySettings({})`) is
  // representable; absent toggles read as `false`.
  constructor(
    private _settings: Partial<Pick<CompanySettings_Read, HydratedCompanySettingKey>>,
  ) {}

  public static parse(proto: CompanySettings_Read) {
    return new CompanySettings(proto);
  }

  public get defaultUntaxedTaxRateScheduleId() {
    return this._settings.default_untaxed_tax_rate_schedule_id ?? null;
  }

  public isEnabled(key: CompanySettingKey) {
    return this._settings[key] ?? false;
  }

  public withSettings(
    overrides: Partial<Pick<CompanySettings_Read, HydratedCompanySettingKey>>,
  ) {
    return new CompanySettings({ ...this._settings, ...overrides });
  }
}
